import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to log off and leave the session?", -1)
const _hoisted_2 = {
  ref: "homeNavigationCircle",
  class: "home-navigation-circle",
  style: {"opacity":"0","visibility":"hidden"}
}
const _hoisted_3 = {
  ref: "invertedHomeNavigationCircle",
  class: "inverted-home-navigation-circle"
}
const _hoisted_4 = {
  key: 1,
  class: "home-navigation-text",
  style: {"position":"relative","left":"-10px"}
}
const _hoisted_5 = {
  key: 2,
  class: "home-navigation-text",
  "data-test": "foundations-log-off"
}
const _hoisted_6 = {
  key: 3,
  class: "home-navigation-text",
  "data-test": "session-home-text"
}

import { computed, getCurrentInstance, ref } from "vue";
import { TimelineLite, TimelineMax } from "gsap";
import { Modal } from "uiv";
import { Analytics } from "../../services/analytics/analytics";
import logOut from "../../services/utilities/log-out";


export default /*#__PURE__*/_defineComponent({
  __name: 'home-navigation',
  props: {
    display: {},
    closeUrl: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const showModal = ref(false);

const instance: any = getCurrentInstance()?.proxy;

const session = computed(() => instance?.$parent);
const display = computed(() => props.display ?? "home");
const closeUrl = computed(() => props.closeUrl ?? "/");

function sendAnalytics(): void {
  Analytics.action("Cancelled Session", "SessionActions", {
    sessionId: session.value.getSessionId(),
    sessionVersion: session.value.getSessionVersion(),
  });
}

function handleClick(): void {
  if (props.display === "log-off") {
    showModal.value = true;
  } else {
    session.value.isLoading = true;
    sendAnalytics();
    setTimeout(() => {
      window.location.href = closeUrl.value;
    }, 2000);
  }
}

function handleModalHide(msg: "ok" | "cancel"): void {
  if (msg === "ok") {
    session.value.isLoading = true;
    sendAnalytics();
    logOut();
  }
}

const colorSwitch = (tl: TimelineMax): TimelineLite =>
  tl
    .to(
      instance.$refs.homeNavigationCircle,
      1 * 0.2,
      {
        autoAlpha: 1,
        ease: session.value.titleVisualEase,
      },
      1,
    )
    .to(
      instance.$refs.invertedHomeNavigationCircle,
      1 * 0.2,
      {
        autoAlpha: 0,
        ease: session.value.titleVisualEase,
      },
      1,
    )
    .to(
      instance.$refs.homeNavigation,
      1 * 0.2,
      {
        css: { className: "-=inverted" },
        autoCss: true,
        ease: session.value.titleVisualEase,
      },
      1,
    );

const colorRevert = (tl: TimelineMax): TimelineLite =>
  tl
    .to(
      instance.$refs.homeNavigationCircle,
      1 * 0.2,
      {
        autoAlpha: 0,
        ease: session.value.titleVisualEase,
      },
      1,
    )
    .to(
      instance.$refs.invertedHomeNavigationCircle,
      1 * 0.2,
      {
        autoAlpha: 1,
        ease: session.value.titleVisualEase,
      },
      1,
    )
    .to(
      instance.$refs.homeNavigation,
      1 * 0.2,
      {
        css: { className: "+=inverted" },
        autoCss: true,
        ease: session.value.titleVisualEase,
      },
      1,
    );

const fadeOut = (tl: TimelineMax): TimelineLite =>
  tl.to(instance.$refs.homeNavigation, 1 * 0.2, {
    autoAlpha: 0,
  });

const fadeIn = (tl: TimelineMax): TimelineLite =>
  tl.to(instance.$refs.homeNavigation, 1 * 0.2, {
    autoAlpha: 1,
  });

__expose({
  colorSwitch,
  colorRevert,
  fadeOut,
  fadeIn,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    ref: "homeNavigation",
    class: _normalizeClass(["home-navigation inverted", {
      'home-navigation-x': display.value === 'x',
      // 'home-navigation-hidden': !shouldDisplayInSession,
    }]),
    onClick: handleClick,
    onKeydown: _withKeys(handleClick, ["enter"]),
    "data-test": "session-home-button"
  }, [
    (display.value === 'log-off')
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 0,
          modelValue: showModal.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
          title: "Log off",
          "ok-text": "Yes",
          "cancel-text": "Cancel",
          "cancel-type": "primary",
          "ok-type": "default",
          onHide: handleModalHide,
          size: "sm",
          "append-to-body": "",
          "data-test": "log-off-modal"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, null, 512),
    _createElementVNode("div", _hoisted_3, null, 512),
    (display.value === 'team')
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "My Team"))
      : (display.value === 'log-off')
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Log off"))
        : (display.value === 'home')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Home"))
          : _createCommentVNode("", true)
  ], 34))
}
}

})